import qs from 'qs';
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import type { ButtonProps } from '@axiom/ui';
import { Button } from '@axiom/ui';
import type { Account, User } from '@axiom/validation';
import { isAhqUser } from '@axiom/utils';

import { ImpersonationClientPickerModal } from '../ImpersonationClientPickerModal/ImpersonationClientPickerModal';
import { ImpersonationAccountPickerModal } from '../ImpersonationAccountPickerModal/ImpersonationAccountPickerModal';

type PickContact = Pick<Account['contacts'][number], 'email' | 'id'>;

export interface EditEngagementButtonProps {
  account?: Account;
  fluid?: boolean;
  label?: string;
  name: string;
  onLoggedOutSubmissionClick: () => void;
  pattern: ButtonProps['pattern'];
  user?: User | null;
  variation: ButtonProps['variation'];
}

export const EditEngagementButton = ({
  account,
  fluid = false,
  label = 'Edit',
  name,
  onLoggedOutSubmissionClick,
  pattern,
  user,
  variation,
}: EditEngagementButtonProps) => {
  const navigate = useNavigate();
  const params = useParams();

  const { accountId, submissionId } = params;

  const [collectData, setCollectData] = useState(false);
  const [impersonationAccount, setImpersonationAccount] = useState<
    Account | undefined
  >();
  const [impersonationContact, setImpersonationContact] = useState<
    Account['contacts'][number] | undefined
  >();

  const referenceAccount = account || impersonationAccount;
  const referenceContact = user?.contact || impersonationContact;

  const buildUrl = (url: string, contact: PickContact) => {
    return isAhqUser(user)
      ? `${url}${qs.stringify({ contactId: contact.id, contactEmail: contact.email }, { addQueryPrefix: true })}`
      : url;
  };

  const clearData = () => {
    setCollectData(false);
    setImpersonationContact(undefined);
    setImpersonationAccount(undefined);
  };

  return (
    <>
      <Button
        fluid={fluid}
        icon={variation === 'minimal' ? 'pencil' : undefined}
        name={name}
        onClick={() => {
          if (!user) {
            onLoggedOutSubmissionClick();
          } else if (!referenceAccount || !referenceContact) {
            setCollectData(true);
          } else {
            navigate(
              buildUrl(`/account/${accountId}/intake/${submissionId}`, {
                email: referenceContact.email,
                id: referenceContact.id,
              })
            );
          }
        }}
        variation={variation}
        pattern={pattern}
      >
        {label}
      </Button>
      {collectData ? (
        <div>
          {referenceAccount ? (
            <ImpersonationClientPickerModal
              account={referenceAccount}
              onClose={() => {
                clearData();
              }}
              selectContact={contact => {
                setImpersonationContact(contact);
                navigate(
                  buildUrl(`/account/${accountId}/intake/${submissionId}`, {
                    email: contact.email,
                    id: contact.id,
                  })
                );
                clearData();
              }}
              submitButtonCopy="Edit Engagement"
            />
          ) : (
            <ImpersonationAccountPickerModal
              onClose={() => {
                clearData();
              }}
              selectAccount={chosenAccount => {
                setImpersonationAccount(chosenAccount);
              }}
            />
          )}
        </div>
      ) : null}
    </>
  );
};
